import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import AuthApi from "../../api/AuthApi";
import { IGlobalSettings, IGlobalSettingsRoot, IRegistrationForm } from "../../config/interfaces";
import { RootState } from "../Store";

interface GlobalSettingsData {
	TERMS_AND_CONDITIONS: IGlobalSettings | null;
	PRIVACY_POLICY: IGlobalSettings | null;
	COOKIES_POLICY: IGlobalSettings | null;
}

interface AuthDataState {
	tempRegisterData: IRegistrationForm;
	globalSettingsData: GlobalSettingsData;
}

const initialRegisterData: IRegistrationForm = {
	role: "ca",
	firstName: "",
	middleName: "",
	lastName: "",
	phoneNumber: "",
	email: "",
	password: "",
	confirmPassword: "",
	terms_accepted: false
};

const initialGSData: GlobalSettingsData = {
	TERMS_AND_CONDITIONS: null,
	PRIVACY_POLICY: null,
	COOKIES_POLICY: null
};

const initialState: AuthDataState = {
	tempRegisterData: { ...initialRegisterData },
	globalSettingsData: { ...initialGSData }
};

const authDataSlice = createSlice({
	name: "authData",
	initialState,
	reducers: {
		setTempRegisterData: (state, action: PayloadAction<IRegistrationForm>) => {
			state.tempRegisterData = { ...action.payload };
		},
		unsetTempRegisterData: (state) => {
			state.tempRegisterData = { ...initialRegisterData };
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			fetchGlobalSettings.fulfilled,
			(state, { payload }: PayloadAction<IGlobalSettingsRoot[]>) => {
				const _gsData: any = {};
				for (let index = 0; index < payload.length; index++) {
					const element = payload[index];
					_gsData[element.key] = element;
				}
				state.globalSettingsData = _gsData;
			}
		);
	}
});

export const { setTempRegisterData, unsetTempRegisterData } = authDataSlice.actions;

export const authDataSelector = (rootState: RootState) => rootState.authData;

export const fetchGlobalSettings = createAsyncThunk<IGlobalSettingsRoot[]>(
	"users/fetchGlobalSettings",
	async (_, { rejectWithValue }) => {
		try {
			const authApi = AuthApi.getInstance();
			const _terms = authApi.getGlobalSettingPublicByKey("TERMS_AND_CONDITIONS");
			const _privacy = authApi.getGlobalSettingPublicByKey("PRIVACY_POLICY");
			const _cookies = authApi.getGlobalSettingPublicByKey("COOKIES_POLICY");
			const [terms, privacy, cookies] = await Promise.all([_terms, _privacy, _cookies]);
			return [{ ...terms }, { ...privacy }, { ...cookies }];
		} catch (error: any) {
			return rejectWithValue(error.response.data);
		}
	}
);

export default authDataSlice.reducer;
